import { fabric } from 'fabric';
import {
  magicFrameChangePersonPhoto,
  toggleMagicFrameEditMode,
  isMagicFrameInEditing,
} from '~core/magicFrame';

const imgReplaceProfilePhoto = document.createElement('img');
imgReplaceProfilePhoto.src =
  '../../assets/custom-controls/sostituisci_foto.png';

const imgModifyPhoto = document.createElement('img');
imgModifyPhoto.src = '../../assets/custom-controls/modifica_foto.png';
const imgEndModifyPhoto = document.createElement('img');
imgEndModifyPhoto.src =
  '../../assets/custom-controls/termina_modifica_foto.png';

const isMagicFrameOrImageInsideIt = (obj) => {
  if (obj.type === 'MagicFrame') {
    return true;
  }

  if (typeof obj._magicFrame !== 'undefined') {
    return true;
  }

  return false;
};

function renderCustomControlReplacePhoto(
  ctx,
  left,
  top,
  styleOverride,
  fabricObject
) {
  if (!isMagicFrameOrImageInsideIt(fabricObject)) {
    return;
  }

  ctx.save();
  ctx.translate(left, top);
  ctx.drawImage(
    imgReplaceProfilePhoto,
    -this.sizeX / 2,
    -this.sizeY / 2,
    this.sizeX,
    this.sizeY
  );
  ctx.restore();
}

function renderCustomControlToggleModifyPhoto(
  ctx,
  left,
  top,
  styleOverride,
  fabricObject
) {
  if (!isMagicFrameOrImageInsideIt(fabricObject)) {
    return;
  }

  const isEditing = isMagicFrameInEditing();

  const btnImage = isEditing ? imgEndModifyPhoto : imgModifyPhoto;
  ctx.save();
  ctx.translate(left, top);
  ctx.drawImage(
    btnImage,
    -this.sizeX / 2,
    -this.sizeY / 2,
    this.sizeX,
    this.sizeY
  );
  ctx.restore();
}

export const initCustomControlsMagicFrame = () => {
  let sizeX = 300;
  let sizeY = 80;

  if (window.canvas.width < 800) {
    sizeX = sizeX / 1.7;
    sizeY = sizeY / 1.7;
  } else if (window.canvas.width < 1700) {
    sizeX = sizeX / 1.9;
    sizeY = sizeY / 1.9;
  }

  fabric.MagicFrame.prototype.controls.replacePhoto = new fabric.Control({
    x: 0.5,
    y: -0.5,
    offsetY: 35,
    offsetX: -100,
    sizeX,
    sizeY,
    cursorStyle: 'pointer',
    visible: false,
    mouseUpHandler: magicFrameChangePersonPhoto,
    render: renderCustomControlReplacePhoto,
  });

  fabric.MagicFrame.prototype.controls.modifyPhoto = new fabric.Control({
    x: 0.5,
    y: -0.5,
    offsetY: 55 + sizeY,
    offsetX: -100,
    sizeX,
    sizeY,
    cursorStyle: 'pointer',
    visible: false,
    mouseUpHandler: () => {
      toggleMagicFrameEditMode();
    },
    render: renderCustomControlToggleModifyPhoto,
  });
};
